import {type GetterTree} from 'vuex';

const getters: GetterTree<ISessionserviceState, RootState> = {
    isAdmin(state)
    {
        return state.isAdmin;
    },

    groups(state)
    {
        return state.groups;
    },

    groupsAssoc(state)
    {
        let groups = {};
        for (const group of state.groups)
        {
            groups[group.id] = group.name;
        }

        return groups;
    },

    allMyGroups(state)
    {
        return state.allMyGroups;
    },

    myGroups(state)
    {
        return state.myGroups;
    },

    editableGroups(state)
    {
        return state.editableGroups;
    },

    documentTypes(state)
    {
        return state.documentTypes;
    },

    documentTypesAssoc(state)
    {
        let types = {};
        for (const type of state.documentTypes)
        {
            types[type.type] = type.name;
        }

        return types;
    },

    hierarchyFormats(state)
    {
        return state.hierarchyFormats;
    },

    editActiveTopic(state): Nullable<string>
    {
        return state.editActiveTopic;
    },

    settings(state): ISessionserviceStateSettings
    {
        return state.settings;
    },

    menu(state): ISessionserviceStateMenu[] | false
    {
        return state.menu;
    },

    exportExists(state): boolean
    {
        return state.exportExists;
    },

    isFreeCouncil(state): boolean
    {
        return state.isFreeCouncil;
    },

};

export default getters;